import React, { useRef, useEffect } from 'react';
import { makeStyles, Paper, IconButton, Tooltip } from '@material-ui/core';
import {
    FormatBold,
    FormatItalic,
    FormatUnderlined,
    FormatListBulleted,
    FormatListNumbered
} from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
    toolbar: {
        display: 'flex',
        gap: theme.spacing(0.5),
        padding: theme.spacing(1),
        borderBottom: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.default
    },
    editor: {
        minHeight: '300px',
        padding: theme.spacing(2),
        outline: 'none',
        '&:focus': {
            outline: 'none'
        }
    },
    container: {
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.shape.borderRadius,
        overflow: 'hidden'
    }
}));

const SimpleHtmlEditor = ({ value, onChange, disabled }) => {
    const classes = useStyles();
    const editorRef = useRef(null);

    useEffect(() => {
        if (editorRef.current && editorRef.current.innerHTML !== value) {
            editorRef.current.innerHTML = value || '';
        }
    }, [value]);

    const handleInput = () => {
        if (onChange && editorRef.current) {
            onChange(editorRef.current.innerHTML);
        }
    };

    const execCommand = (command, value = null) => {
        document.execCommand(command, false, value);
        editorRef.current.focus();
        handleInput();
    };

    return (
        <Paper className={classes.container} variant="outlined">
            <div className={classes.toolbar}>
                <Tooltip title="Negrito">
                    <IconButton
                        size="small"
                        onClick={() => execCommand('bold')}
                        disabled={disabled}
                    >
                        <FormatBold fontSize="small" />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Itálico">
                    <IconButton
                        size="small"
                        onClick={() => execCommand('italic')}
                        disabled={disabled}
                    >
                        <FormatItalic fontSize="small" />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Sublinhado">
                    <IconButton
                        size="small"
                        onClick={() => execCommand('underline')}
                        disabled={disabled}
                    >
                        <FormatUnderlined fontSize="small" />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Lista com marcadores">
                    <IconButton
                        size="small"
                        onClick={() => execCommand('insertUnorderedList')}
                        disabled={disabled}
                    >
                        <FormatListBulleted fontSize="small" />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Lista numerada">
                    <IconButton
                        size="small"
                        onClick={() => execCommand('insertOrderedList')}
                        disabled={disabled}
                    >
                        <FormatListNumbered fontSize="small" />
                    </IconButton>
                </Tooltip>
            </div>
            <div
                ref={editorRef}
                className={classes.editor}
                contentEditable={!disabled}
                onInput={handleInput}
                suppressContentEditableWarning
            />
        </Paper>
    );
};

export default SimpleHtmlEditor;
